import publicIp from "public-ip";
import { v4 as uuidv4 } from "uuid";

export const getHiddenAttribute = async (name) => {
  let value = null;

  switch (name) {
    case "ip": {
      value = await publicIp.v4();
    }
      break;
    case "clientAgent": {
      value = navigator.userAgent;
    }
      break;
    case "language": {
      value = "en";
    }
      break;
    case "amountInUSDT": {
      value = "0";
    }
      break;
    case "fio": {
      value = "Firstname Lastname";
    }
      break;
    case "firstName": {
      value = "John";
    }
      break;
    case "lastName": {
      value = "Smith";
    }
      break;
    case "email": {
      value = "johnsmith@gmail.com";
    }
      break;
    case "recipientId": {
      value = uuidv4();
    }
      break;
    case "recipientBank": {
      value = "VISAMC";
    }
      break;
    case "stablingCurrency": {
      value = "";
    }
      break;
  }

  return value;
};